import type { BoardCategory } from "@/types/board";

/**
 * 게시판 카테고리 정보 상수
 *
 * 웹사이트의 주요 메뉴와 페이지들을 정의합니다.
 * 각 카테고리는 고유 ID, 표시 라벨, URL 경로, 메인 메뉴 그룹을 포함합니다.
 */
export const BOARD_CATEGORIES: BoardCategory[] = [
  {
    id: "greeting",
    label: "인사말",
    href: "/greeting",
    mainMenu: "RISE사업단",
  },
  {
    id: "organization",
    label: "조직도",
    href: "/organization",
    mainMenu: "RISE사업단",
  },
  {
    id: "living-research",
    label: "생활연구소",
    href: "/organization?department=living-research",
    mainMenu: "RISE사업단",
  },
  {
    id: "location",
    label: "오시는길",
    href: "/location",
    mainMenu: "RISE사업단",
  },
  {
    id: "rise-business",
    label: "RISE추진사업",
    href: "/rise-business",
    mainMenu: "RISE추진사업",
  },
  {
    id: "rise-projects",
    label: "사업공고",
    href: "/announcements",
    mainMenu: "알림마당",
  },
  {
    id: "notices",
    label: "공지사항",
    href: "/notices",
    mainMenu: "알림마당",
  },
  {
    id: "recruit",
    label: "채용공고",
    href: "/recruit",
    mainMenu: "알림마당",
  },
  {
    id: "resources",
    label: "자료실",
    href: "/resources",
    mainMenu: "자료실",
  },
  {
    id: "newsletter",
    label: "뉴스레터",
    href: "/newsletters",
    mainMenu: "홍보",
  },
];

/**
 * 게시판 공통 설정 상수
 *
 * 게시판에서 사용되는 공통적인 설정값들을 정의합니다.
 * 페이지네이션, 검색 기능 등에 활용됩니다.
 */
export const BOARD_CONSTANTS = {
  /** 페이지당 표시할 게시물 수 */
  ITEMS_PER_PAGE: 10,
  /** 검색 유형 옵션 */
  SEARCH_TYPES: [
    { value: "all", label: "전체" },
    { value: "title", label: "제목" },
    { value: "content", label: "내용" },
    { value: "author", label: "작성자" },
  ],
};

/**
 * 기간 제한이 있는 카테고리 목록
 *
 * 채용공고와 RISE사업공고는 기간이 지나면 자동으로 비활성화됩니다.
 * 이 상수는 기간 제한 기능을 적용할 카테고리를 정의합니다.
 */
export const PERIOD_CATEGORIES = ["recruit", "rise-projects"] as const;
